<!--新闻中心-->
<template>
  <div>
    <!--公司新闻导航图-->
    <el-row v-show="corporation_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in carouselList' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--行业资讯导航图-->
    <el-row v-show="trade_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in industryList' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--埃文博士导航图-->
    <el-row v-show="doctor_visible">
      <el-col :span="24">
        <div class='wow animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in doctorList' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--tabs标签页-->
    <el-row>
      <el-col :span="4"><div class="grid_content"></div></el-col>
      <el-col :span="16">
        <div class='wow animate__animated animate__fadeInUp animate__slower'>
          <div class="grid_content">
            <el-tabs v-model="activeName" @tab-click="handleClick">

             <!--公司新闻-->
              <el-tab-pane label="公司新闻" name="journalism">
                <ul>
                  <li class='newsList' v-for='item in homeCaseDataList' :key='item.id' @click='doctor(item)'>
                    <div class='titleImg'>
                      <el-image class='doctorImage'
                                :src='item.imageUrl'
                      />
                    </div>
                    <div class='titleArea' @click='doctor(item)'>
                      <h2 class='title'><a>{{ item.title }}</a></h2>
                      <p class='briefIntroduction'> <a> {{ item.profile }} </a> </p>
                      <p class='date'>{{ item.releaseTime }}            编辑：{{ item.author }}</p>
                    </div>
                  </li>

                </ul>
               <!--分页-->
                <el-pagination class='paging'
                  small
                  layout="prev, pager, next"
                  next-text="下一页"
                  prev-text="上一页"
                  :page-size="1"
                  @prev-click='upPage'
                  @next-click='upPage'
                  @current-change='upPage'
                  :total='total'
                  :page.sync='queryParams.pageNum'
                  >
                </el-pagination>
              </el-tab-pane>

              <!--行业资讯-->
              <el-tab-pane label="行业资讯" name="industry">
                <ul>
                  <li class='newsList' v-for='item in industryDataList' :key='item.id' @click='doctor(item)'>
                    <div class='titleImg'>
                      <el-image class='doctorImage'
                                :src='item.imageUrl'
                      />
                    </div>
                    <div class='titleArea' @click='doctor(item)'>
                      <h2 class='title'><a>{{ item.title }}</a></h2>
                      <p class='briefIntroduction'> <a> {{ item.profile }} </a> </p>
                      <p class='date'>{{ item.releaseTime }}            编辑：{{ item.author }}</p>
                    </div>
                  </li>

                </ul>
                <!--分页-->
                <el-pagination class='paging'
                               small
                               layout="prev, pager, next"
                               next-text="下一页"
                               prev-text="上一页"
                               :page-size="1"
                               @prev-click='upIndustryPage'
                               @next-click='upIndustryPage'
                               @current-change='upIndustryPage'
                               :total='industryTotal'
                               :page.sync='industryParams.pageNum'
                >
                </el-pagination>
              </el-tab-pane>

              <!--埃文博士观点-->
              <el-tab-pane label="埃文博士观点" name="avi">
                <ul>
                  <li class='newsList' v-for='item in doctorDataList' :key='item.id' @click='doctor(item)'>
                    <div class='titleImg'>
                      <el-image class='doctorImage'
                                :src='item.imageUrl'
                      />
                    </div>
                    <div class='titleArea' @click='doctor(item)'>
                      <h2 class='title'><a>{{ item.title }}</a></h2>
                      <p class='briefIntroduction'> <a> {{ item.profile }} </a> </p>
                      <p class='date'>{{ item.releaseTime }}            作者：{{ item.author }}</p>
                    </div>
                  </li>

                </ul>
                <!--分页-->
                <el-pagination class='paging'
                               small
                               layout="prev, pager, next"
                               next-text="下一页"
                               prev-text="上一页"
                               :page-size="1"
                               @prev-click='upDoctorPage'
                               @next-click='upDoctorPage'
                               @current-change='upDoctorPage'
                               :total='doctorTotal'
                               :page.sync='doctorParams.pageNum'
                >
                </el-pagination>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid_content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { selectCarouselPicture, webQueryAll } from '../../api/auth'

export default {
  created () {
    this.webQueryAll(1)
    this.selectCompanyPicture(7)
    this.selectIndustryPicture(8)
    this.selectDoctorPicture(9)
  },
  activated () {
    if (localStorage.getItem('newsCenter') === '') {
      this.activeName = 'journalism'
      this.corporation_visible = true
      this.trade_visible = false
      this.doctor_visible = false
    } else {
      this.activeName = localStorage.getItem('newsCenter')
      if (this.activeName === 'journalism') {
        this.corporation_visible = true
        this.trade_visible = false
        this.doctor_visible = false
        if (this.homeCaseDataList.length === 0) {
          this.webQueryAll(1)
        }
      } else if (this.activeName === 'industry') {
        this.corporation_visible = false
        this.trade_visible = true
        this.doctor_visible = false
        if (this.industryDataList.length === 0) {
          this.industryAll(2)
        }
      } else if (this.activeName === 'avi') {
        this.corporation_visible = false
        this.trade_visible = false
        this.doctor_visible = true
        if (this.doctorDataList.length === 0) {
          this.doctorAll(3)
        }
      }
    }
  },
  data () {
    return {
      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      dataList: [],

      homeCaseDataList: [],
      industryDataList: [],
      doctorDataList: [],
      // 总条数
      total: 0,
      industryTotal: 0,
      doctorTotal: 0,
      corporation_visible: true,
      trade_visible: false,
      doctor_visible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        type: 1
      },
      industryParams: {
        pageNum: 1,
        pageSize: 20,
        type: 1
      },
      doctorParams: {
        pageNum: 1,
        pageSize: 20,
        type: 1
      },
      activeName: 'journalism',
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      carouselList: [],
      industryList: [],
      doctorList: [],
      carouselIndustryParams: {
        type: 5
      },
      carouselParams: {
        type: 5
      },
      carouselDoctorParams: {
        type: 5
      }
    }
  },
  mounted () {
    new this.$wow.WOW().init({// 新建实列
      boxClass: 'wow', // class名字
      animateClass: 'animate__animated', // animateclass动画库类名,和当前animate动画库决定
      offset: 0, // 到元素距离触发动画（当默认为0）
      mobile: true, // 在移动设备上触发动画（默认为true）
      live: true // 对异步加载的内容进行操作（默认为true）
    })
  },
  methods: {
    jump (raw) {
    },
    /** 公司新闻滚动图  */
    selectCompanyPicture (raw) {
      let that = this
      that.carouselParams.type = raw
      selectCarouselPicture(that.carouselParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.carouselList = res
      })
    },
    /** 行业新闻滚动图  */
    selectIndustryPicture (raw) {
      let that = this
      that.carouselIndustryParams.type = raw
      selectCarouselPicture(that.carouselIndustryParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.industryList = res
      })
    },
    /** 埃文博士滚动图  */
    selectDoctorPicture (raw) {
      let that = this
      that.carouselDoctorParams.type = raw
      selectCarouselPicture(that.carouselDoctorParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.doctorList = res
      })
    },
    /** 公司新闻 */
    // eslint-disable-next-line vue/no-dupe-keys
    webQueryAll (type) {
      let that = this
      that.queryParams.type = type
      webQueryAll(that.queryParams).then(res => {
        res.records.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        this.total = res.pages
        this.homeCaseDataList = res.records
      })
    },
    /** 行业新闻 */
    // eslint-disable-next-line vue/no-dupe-keys
    industryAll (type) {
      let that = this
      that.industryParams.type = type
      webQueryAll(that.industryParams).then(res => {
        res.records.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        this.industryTotal = res.pages
        this.industryDataList = res.records
      })
    },
    /** 埃文博士 */
    // eslint-disable-next-line vue/no-dupe-keys
    doctorAll (type) {
      let that = this
      that.doctorParams.type = type
      webQueryAll(that.doctorParams).then(res => {
        res.records.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.homeImage)
        })
        this.doctorTotal = res.pages
        this.doctorDataList = res.records
      })
    },
    handleClick (tab, event) {
      if (tab.name === 'journalism') {
        this.corporation_visible = true
        this.trade_visible = false
        this.doctor_visible = false
        if (this.homeCaseDataList.length === 0) {
          this.webQueryAll(1)
        }
      } else if (tab.name === 'industry') {
        this.corporation_visible = false
        this.trade_visible = true
        this.doctor_visible = false
        if (this.industryDataList.length === 0) {
          this.industryAll(2)
        }
      } else if (tab.name === 'avi') {
        this.corporation_visible = false
        this.trade_visible = false
        this.doctor_visible = true
        if (this.doctorDataList.length === 0) {
          this.doctorAll(3)
        }
      }
    },
    upPage (raw) {
      this.queryParams.pageNum = raw
      this.webQueryAll(1)
    },
    upDoctorPage (raw) {
      this.doctorParams.pageNum = raw
      this.doctorAll(3)
    },
    upIndustryPage (raw) {
      this.industryParams.pageNum = raw
      this.industryAll(2)
    },
    doctor (raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
          type: 2
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.block{
  .image-slot{
    width: 100%;
    height: 300px;
    margin-bottom: 40px;
  }
}
.doctorImage{
  width: 180px;
  height: 100px;
  cursor: pointer;
}
.grid_content{
  min-height:50px;
  //分页
  .paging{
    margin: 20px;
    text-align: center;
  }
  //ul样式
  ul{
    min-height: 650px;
    li{
      border: 1px solid #11a84e;
      border-radius: 10px;
      height:120px ;
      padding: 10px;
      margin-bottom: 10px;
      .titleImg{
        float: left;
        img{
          width: 180px;
          height: 100px;
        }
      }
      .titleArea{
        margin-left:190px;
        height: 100px;
        position:relative;
        h2{
          font-size: 16px;
          margin-bottom:5px;
          font-weight: bold;
          font-family: "MicrosoftYaHei";
          overflow: hidden;        /*内容会被修剪，并且其余内容是不可见的*/
          text-overflow:ellipsis;  /*显示省略符号来代表被修剪的文本。*/
          white-space: nowrap;     /*文本不换行*/
          a{
            color: #333;
          }
          a:hover{
            color: #11a84e;
          }
        }
        .briefIntroduction{
          font-size: 14px;
          font-weight: bold;
          font-family: "MicrosoftYaHei";
          a{
            color: #666;
          }
          a:hover{
            color: #11a84e;
          }
        }
        .date{
          font-size: 14px;
          color: #999;
          position:absolute;
          bottom:0;
        }
      }
    }
  }
}

//Tabs标签页
::v-deep .el-tabs{
  display: block;
  //width:500px;
  margin: 0 auto;
}
::v-deep .el-tabs__item {
  padding: 0;
  width: 250px;
  height: 50px;
  line-height: 50px;
  font-size:22px !important;
  font-family: "MicrosoftYaHei";
  text-align: center;
  position: relative;
}
//tabs下划线
::v-deep .el-tabs__active-bar{
  background-color: #11a84e;
}
//tabs鼠标移入事件
::v-deep .el-tabs__item:hover{
  color: #11a84e;
}
//tabs鼠标点击事件
::v-deep .el-tabs__item.is-active {
  color: #11a84e;
}
// 默认选中的样式
::v-deep .el-tabs__nav-scroll .el-tabs__item.is-active {
  color: #11a84e;
}

</style>
